import React, { useState, useRef } from "react";
import DataGrid, {
  Column,
  Pager,
  Paging,
  SearchPanel,
  HeaderFilter,
  Selection,
  Editing,
  Grouping,
  GroupPanel,
  Export,
  Sorting,
  Toolbar,
  Item,
  ColumnChooser,
  Scrolling,
  MasterDetail,
} from "devextreme-react/data-grid";
import { apiGet } from "api/api-ccp";
import CustomStore from "devextreme/data/custom_store";
import { useDelete, useUpdate } from "@hooks/useCcpApi";
import { onExportingCCPExcel } from "utils/helpers";
import { useDispatch, useSelector } from "react-redux";
import CheckBox from "devextreme-react/check-box"; // Assuming DevExtreme
import { useNavigate } from "react-router-dom";
import CCP_API from "api/ccpAPi";
import notify from "devextreme/ui/notify";
import { confirm } from "devextreme/ui/dialog"; // Import confirm from DevExtreme
import Accordion from "devextreme-react/accordion";
import CCPEdit from "./CCPEdit";
import { Button } from "devextreme-react";
import CCPEdit1 from "./CCPEdit1";

const exportFormats = ["xlsx"];

export default function CCPTable({ onExpand, isExpanded }) {
  const [pageSize, setPageSize] = useState(20);
  const [totalCount, setTotalCount] = useState(0);
  const navigate = useNavigate();
  const batchID = useSelector((state) => state.overview.batchId);
  const updateMutation = useUpdate("updateCCP", CCP_API.CCP);
  const deleteMutation = useDelete("deleteCCP", CCP_API.delete);
  const [selectedIds, setSelectedIds] = useState([]); // ✅ Track selected row IDs
  const dispatch = useDispatch();
  const [bool, setBool] = useState(true);
  const gridRef = useRef(null);
  const [editInspection1, setEditInspection1] = useState(false);
  const [editInspection2, setEditInspection2] = useState(false);
  const [sortSelected, setSortSelected] = useState(false);

  const onSelectionChanged = async (e) => {
    const selectedData = await e.component.getVisibleRows();
    const keys = await e.component.getSelectedRowKeys();
    console.log(await e.component.getSelectedRowKeys(), "selected rows");
  };

  const collapseDetail = ({ data }) => {
    const accordionItems = data.ccpTests.map((test, index) => ({
      title: test?.type === 1 ? "Production Startup" : "End Production",
      content: (
        <div className="whitespace-break-spaces">
          {test?.type === 1 ? (
            <CCPEdit id={test?.ccP_ID} />
          ) : (
            <CCPEdit1 id={test?.ccP_ID} />
          )}
        </div>
      ),
    }));

    return (
      <Accordion
        items={accordionItems}
        itemTitleRender={(item) => item.title}
        itemRender={(item) => item.content}
        collapsible={true}
        multiple={true}
      />
    );
  };

  const handleExportSelected = (e) => {
    const selected = [
      ...new Set(gridRef.current.instance().getSelectedRowKeys()),
    ];

    if (e.format === "xlsx" || e.format === "pdf") {
      if (e.selectedRowsOnly && selected.length === 0) {
        notify({
          message: "Please select at least one row before exporting",
          type: "error",
          displayTime: 2000,
          position: {
            my: "top right",
            at: "top right",
            of: window,
          },
        });
        e.cancel = true; // Prevent export
        return;
      }

      // Call the appropriate export function
      if (e.format === "xlsx") {
        onExportingCCPExcel({ ...e, selectedRows: selected }); // Pass unique selected rows
      }
    }
  };
  const sendSelectedIds = async () => {
    const selected = gridRef.current.instance().getSelectedRowsData();

    if (selected?.length === 0) {
      notify({
        message: "No rows selected for deletion",
        type: "error",
        displayTime: 2000,
        position: {
          my: "top right",
          at: "top right",
          of: window,
        },
      });
      return;
    }

    const result = await confirm(
      "Are you sure you want to delete the selected Record?",
      "Confirm Deletion"
    );

    if (result) {
      try {
        for (const item of selected) {
          for (const test of item.ccpTests) {
            await deleteMutation.mutateAsync({ CCPId: test.ccP_ID }); // Call API for each nested object
          }
        }

        notify({
          message: "Selected rows deleted successfully",
          type: "success",
          displayTime: 2000,
          position: {
            my: "top right",
            at: "top right",
            of: window,
          },
        });
        dataSource.load();
      } catch (error) {
        console.error("Error deleting selected IDs:", error);
        notify({
          message: "Error deleting selected rows",
          type: "error",
          displayTime: 2000,
          position: {
            my: "top right",
            at: "top right",
            of: window,
          },
        });
      }
    }
  };
  const dataSource = new CustomStore({
    key: "ccP_ID",
    load: async (loadOptions) => {
      const take = loadOptions.take || pageSize;
      const skip = loadOptions.skip || 0;
      const pageNo = Math.floor(skip / take);

      try {
        const response = await apiGet(CCP_API.CCPs, {
          PageNo: pageNo,
          PageSize: take,
          // ⚠️ DO NOT send sort info to the backend if it doesn't support it
        });

        let ccpdata = response?.data || [];

        ccpdata = ccpdata.map((item) => ({
          ...item,
          ccP_ID: item.ccpTests
            ? item.ccpTests.map((test) => test.ccP_ID).join("-") // Combine qcP_IDs with a delimiter
            : null, // Handle cases where qcpTests is empty or undefined
        }));

        if (sortSelected && loadOptions.sort?.length > 0) {
          const { selector, desc } = loadOptions.sort[0];
          ccpdata.sort((a, b) => {
            const aValue = a[selector];
            const bValue = b[selector];

            if (aValue < bValue) return desc ? 1 : -1;
            if (aValue > bValue) return desc ? -1 : 1;
            return 0;
          });
        }

        setTotalCount(response?.info?.totalRecordsCount);

        console.log(response?.info?.totalRecordsCount);
        if (
          response?.info?.totalRecordsCount > 0 &&
          response?.info?.totalRecordsCount <= 10
        ) {
          setPageSize(10);
        } else if (
          response?.info?.totalRecordsCount > 10 &&
          response?.info?.totalRecordsCount <= 20
        ) {
          setPageSize(10);
        } else if (response?.info?.totalRecordsCount > 20) {
          setPageSize(50);
        }

        return {
          data: ccpdata,
          totalCount: response?.info?.totalRecordsCount,
        };
      } catch (error) {
        console.error("Error loading data:", error);
        throw error;
      }
    },
    update: async (key, values) => {
      try {
        const modifiedData = {
          //   ccP_ID: values.ccP_ID,
          batchNo: values.batchNo,
          licensePlate: values.licensePlate,
          company: values.company,
          driver: values.driver,
          truckTemp: values.truckTemp,
          truckClean: values.truckClean,
          status: true,
          //   createdBy: values.createdBy,
          //   createdDateUTC: values.createdDateUTC,
          //   updatedBy: values.updatedBy,
          //   updatedDateUTC: values.updatedDateUTC,
        };

        await updateMutation.mutateAsync({
          params: { id: key }, // ✅ Pass "id" inside params
          data: modifiedData, // ✅ Pass update values separately
        });

        console.log(values, key);

        return values;
      } catch (error) {
        console.error("Error updating record:", error);
        throw error;
      }
    },
    remove: async (key) => {
      console.log("hello", key);
      // try {
      //   await deleteMutation.mutateAsync({ CCPId: selectedIds }); // ✅ Use the mutation
      //   console.log("Successfully deleted selected IDs:", selectedIds);
      //   notify({
      //     message: "Selected rows deleted successfully",
      //     type: "success",
      //     displayTime: 2000,
      //     position: {
      //       my: "top right",
      //       at: "top right",
      //       of: window,
      //     },
      //   });
      // } catch (error) {
      //   console.error("Error deleting record:", error);
      //   throw error;
      // }
    },
  });

  const CheckboxEditor = ({ value = false, onValueChanged }) => {
    const [checked, setChecked] = useState(Boolean(value));

    const handleChange = (e) => {
      const newValue = e.value;
      setChecked(newValue); // Update local state
      if (typeof onValueChanged === "function") {
        onValueChanged(newValue); // Notify parent
      }
    };

    return <CheckBox value={checked} onValueChanged={handleChange} />;
  };

  const [secondTableSelection, setSecondTableSelection] = useState(null);

  return bool ? (
    <React.Fragment>
      <p className="font-medium text-xl flex justify-center lg:mr-36">
        CCP Inspect Test
      </p>

      <DataGrid
        className="dx-card content-block border-0"
        dataSource={dataSource}
        keyExpr="ccP_ID"
        ref={gridRef}
        showBorders={false}
        columnAutoWidth={true}
        columnHidingEnabled={true}
        hoverStateEnabled={true}
        rowAlternationEnabled={true}
        allowColumnReordering={false}
        allowColumnResizing={false}
        preserveSelectedRowKeys={true}
        // selectedRowKeys={selectedIds}
        loadPanel={{
          enabled: true,
          text: "Processing...",
          showIndicator: false,
          indicatorSrc: "/loaderimage.gif", // Optional: Custom loading indicator
          shading: false,
          shadingColor: "rgba(255, 255, 255, 0.7)",
        }}  
        remoteOperations={{ paging: true, sorting: true }}
        rowDragging={{ allowReordering: false, showDragIcons: false }}
        onExporting={handleExportSelected}
        onSelectionChanged={onSelectionChanged} // ✅ Capture selection changes
        onRowUpdating={(e) => {
          // Merge the old data with the new changes
          e.newData = { ...e.oldData, ...e.newData }; // ✅ Merge old and new data
        }}
        onRowClick={(e) => {
          if (!e.event.target.closest(".dx-checkbox")) {
            // navigate(`/quality/fillet/ccp/view/${e.data.id}`);
          }
        }}
        onOptionChanged={(e) => {
          if (e.fullName === "paging.pageSize") {
            setPageSize(e.value);
          }
          if (e.value === "asc" || e.value === "desc") {
            setSortSelected(true); // Set sortSelected to true when sorting changes
          }
        }}
      >
        <Editing mode="cell" allowUpdating={true} /> {/* ✅ Enable Editing */}
        <Scrolling mode="standard" />
        <Paging enabled={true} pageSize={pageSize} />
        <Pager
          visible={totalCount > 10 && true}
          showPageSizeSelector={true}
          allowedPageSizes={[10, 20, 50]}
          showInfo={true}
          showNavigationButtons={true}
        />
        <HeaderFilter visible={true} />
        <SearchPanel visible={true} placeholder="Search..." />
        <Sorting
          mode="multiple"
          showSortIndexes={false}
          clearSortingText="Clear sorting"
        />
        <Selection
          mode="multiple"
          selectAllMode="page" // or "allPages" if needed
          showCheckBoxesMode="always" // or "always"
          deferred={false} //
        />
        <GroupPanel visible={true} />
        <Grouping autoExpandAll={true} />
        <Export
          enabled={true}
          formats={exportFormats}
          allowExportSelectedData={true}
        />
        <Editing mode="row" allowUpdating={true} allowDeleting={true} />
        <ColumnChooser enabled={false} />
        {/* Columns */}
        {/* <Column
          dataField="supplierID"
          caption="Supplier"
          lookup={{
            dataSource: isSuppliersLoading ? [] : suppliers?.data || [],
            valueExpr: "supplierID",
            displayExpr: "supplierName"
          }}
          editCellRender={(cellInfo) => {
            const supplier = suppliers?.data?.find(s => s.supplierID == cellInfo.value);
            console.log("supplier", supplier)
            return (
              <SelectBox
                dataSource={suppliers?.data || []}
                valueExpr="supplierID"
                displayExpr="supplierName"
                defaultValue={supplier ? supplier.supplierID : null}
                onValueChanged={(e) => cellInfo.setValue(e.value)}
              />
            );
          }}
        /> */}
        {/* <Column
          sortOrder="asc"
          alignment="left"
          dataField="ccP_ID"
          caption="CCP ID"
          allowHeaderFiltering={false}
        /> */}
        <Column
          allowHeaderFiltering={false}
          sortOrder="asc"
          dataField="batchNo"
          caption="Batch Num."
        />
        {/* <Column
          allowHeaderFiltering={false}
          sortOrder="asc"
          dataField="company"
          caption="Company"
        />
        <Column
          allowHeaderFiltering={false}
          sortOrder="asc"
          dataField="driver"
          caption="Driver"
        />
        <Column
          sortOrder="asc"
          dataField="licensePlate"
          caption="License Plate"
          allowHeaderFiltering={false}
        /> */}
        {/* <Column dataField="truckClean" caption="Truck Clean" /> */}
        {/* <Column
          dataField="statusName"
          caption="Status"
          lookup={{
            dataSource: isStatusesLoading ? [] : statuses?.data || [],
            valueExpr: "statusID",
            displayExpr: "statusName"
          }}
            editCellRender={(cellInfo) => {
            const status = statuses?.data?.find(s => s.statusID == cellInfo.value);
            console.log("status", status, statuses)
            return (
              <SelectBox
                dataSource={statuses?.data || []}
                valueExpr="statusID"
                displayExpr="statusName"
                defaultValue={status ? status.statusID : null}
                onValueChanged={(e) => cellInfo.setValue(e.value)}
              />
            );
          }}
        /> */}
        {/* <Column
          allowHeaderFiltering={false}
          dataField="createdDateUTC"
          caption="Date"
          dataType="date"
          sortOrder="desc"
          sortIndex={0}
          allowSorting={true} // Add this to each column
        /> */}
        {/* <Column dataField="status" caption="Status" /> */}
        <Column
          caption="Action"
          type="buttons"
          allowSorting={true}
          visible={false}
          buttons={[]} // Remove the "Edit" button from the column
        />
        <Column
          caption="Action"
          width={100}
          cssClass="custom-text-left"
          cellRender={(data) => (
            <div className="flex gap-2 justify-center">
              <i
                onClick={() =>
                  navigate(
                    `/quality/fillet/ccp/view/overview/?batchNum=${data?.data?.batchNo}`
                  )
                }
                className="ri-eye-line cursor-pointer"
              ></i>
            </div>
          )}
        />
        <Toolbar>
          <Item name="searchPanel" location="before" />
          <Item
            location="center"
            render={() => (
              <div className="lg:grid grid-cols-3 gap-2 hidden">
                <div>
                  Total Records:{" "}
                  <span className="font-medium">{totalCount}</span>
                </div>
              </div>
            )}
          />
          <Item
            widget="dxButton"
            onClick={() => {
              navigate("/quality/fillet/ccp/add");
            }}
            options={{ icon: "add", text: "", hint: "Add New Record" }}
            location="after"
          />
          <Item
            widget="dxButton"
            onClick={sendSelectedIds}
            options={{
              icon: "trash",
              text: "",
              hint: "Delete Selected Record",
            }}
            location="after"
          />
          {/* <Item
            widget="dxButton"
            onClick={() => {
              const selectedRow = gridRef.current
                .instance()
                .getSelectedRowsData()[0];
              if (selectedRow) {
                navigate(`/quality/fillet/ccp/edit/${selectedRow?.ccP_ID}`, {
                  state: selectedRow,
                });
              } else {
                notify({
                  message: "Please select a row to edit",
                  type: "error",
                  displayTime: 2000,
                  position: {
                    my: "top right",
                    at: "top right",
                    of: window,
                  },
                });
              }
            }}
            options={{ icon: "edit", text: "", hint: "Edit Selected Record" }}
            location="after"
          /> */}
          <Item name="exportButton" showText="always" />
        </Toolbar>
        {/* table row collapse */}
        <MasterDetail enabled={true} render={collapseDetail} />
      </DataGrid>
    </React.Fragment>
  ) : (
    <></>
  );
}
